<template>
<div container--fluid>
    <v-layout>
        <HpcSubscriptionModule></HpcSubscriptionModule>
    </v-layout>
</div>
</template>

<script>
import HpcSubscriptionModule from '@modules/hpcsubscription/index.vue';

export default {
    name: 'hpcsubscription',
    components: {
        HpcSubscriptionModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
